<template>
  <div class="container-fluid animate__animated animate__fadeIn animate__faster">
    <div class="row">
      <div class="col-md-12 my-2">
        <h4>Help & FAQ'S</h4>
        <hr>
      </div>
      <EjwFaq v-if="env == 'EJW'"/>
      <CheneyFaq v-else-if="env == 'EJW-CHENEY'"/>
      <MeritSupplyFaq v-else-if="company == 'Merit Supply'"/>
      <LanFaq v-else/>
    </div>
  </div>
</template>

<script>
  import EjwFaq from './EjwFaq.vue'
  import LanFaq from './LanFaq.vue'
  import CheneyFaq from './CheneyFaq.vue'
  import MeritSupplyFaq from './MeritSupplyFaq.vue'

  export default {
    inject:['env'],
    components:{
      EjwFaq,
      CheneyFaq,
      LanFaq,
      MeritSupplyFaq
    },
    computed:{
      company(){return this.$store.getters.sessionCompany}
    }
  }
</script>